import React from 'react';
import { useEffect, useRef } from "react";
import { render } from "react-dom";

const ShadowWrapper = ({ children, stylesheetUrl }: { children: React.ReactElement, stylesheetUrl?: string }) => {
  const hostRef = useRef<HTMLDivElement>(null);
  const shadowRootRef = useRef<ShadowRoot | null>(null);

  useEffect(() => {
    if (!hostRef.current) return;

    shadowRootRef.current = hostRef.current.attachShadow({ mode: 'open' });

    const mountPoint = document.createElement('div');
    const styleElement = document.createElement('link');
    styleElement.href = stylesheetUrl || 'https://unpkg.com/happi-widget/dist/index.css';
    styleElement.rel = 'stylesheet';
    shadowRootRef.current.appendChild(styleElement);
    shadowRootRef.current.appendChild(mountPoint);

    render(children, mountPoint);
  }, [children]);

  return <div ref={hostRef} />;
}

export default ShadowWrapper;
